import * as React from "react";
import ButtonLink from "../../ButtonLink";
const PageButtonLink = ({
  children,
  onPageChange,
  size
}) => /*#__PURE__*/React.createElement(ButtonLink, {
  onClick: () => onPageChange(children),
  type: "secondary",
  size: size
}, children);
export default PageButtonLink;